<form novalidate #currentForm="ngForm">
  <div class="setup">
    <div class="section-container">
      <div class="label-data label">
        <div class="label"><b>Name</b></div>
      </div>
      <div class="group test-name">
        <input
          matInput
          autocomplete="off"
          type="text"
          class="input-data"
          name="testName"
          #testNameInput="ngModel"
          [(ngModel)]="testName"
          (ngModelChange)="nameUpdated()"
          maxlength="80"
          [disabled]="nameDisabled"
          required
        />
        <div
          class="error"
          *ngIf="testNameInput.invalid && (testNameInput.dirty || testNameInput.touched)"
        >
          <mat-error *ngIf="testNameInput?.errors?.required">Name is required</mat-error>
          <mat-error *ngIf="testNameInput.errors.regex && !testNameInput.errors.required"
            >Name should not contain '?,%,/' special characters</mat-error
          >
        </div>
        <div *ngIf="nameExist">
          <mat-error>Name already exist</mat-error>
        </div>
      </div>
    </div>

    <div class="section-container site-container">
      <div class="label-data label"><b>Endpoints</b></div>
      <div class="site-section">
        <div class="originator">
          <nrwl-agent-picker
            [testType]="testType"
            [originatorDevice]="selectedOriginator"
            [editMode]="editMode"
            [originatorMultiSelection]="false"
            [testMode]="testMode"
            [showTestMode]="false"
            (emitAgents)="onAgentChange($event)"
          ></nrwl-agent-picker>
          <div *ngIf="selectedOriginator" class="originator-config-container">
            <div class="section-data" *ngIf="showFormField(configMapping?.TRANSMIT_INTERFACE)">
              <div class="group">
                <div class="label">Transmit interface</div>
                <mat-select
                  class="option-list"
                  #txInterfaceInput="ngModel"
                  [(ngModel)]="formField.txInterface"
                  name="txInterface"
                  (selectionChange)="onTxInterfaceChange()"
                  required
                >
                  <mat-option *ngFor="let tx of txInterfaceTypes" [value]="tx.value">{{
                    tx.name
                  }}</mat-option>
                </mat-select>
              </div>
              <div class="tx-image">
                <img [src]="txTypeImage" />
              </div>
              <div class="group">
                <div class="label">MAC address *</div>
                <input
                  matInput
                  autocomplete="off"
                  type="text"
                  name="macAddress"
                  [(ngModel)]="formField.macAddress"
                  #macAddressInput="ngModel"
                  (ngModelChange)="onMacAddressChange()"
                  [pattern]="macRegex"
                  [disabled]="true"
                  required
                />
                <div
                  class="error"
                  *ngIf="
                    macAddressInput.invalid && (macAddressInput.dirty || macAddressInput.touched)
                  "
                >
                  <mat-error *ngIf="macAddressInput?.errors?.required"> Required</mat-error>
                  <mat-error *ngIf="macAddressInput.errors?.pattern"
                    >Mac Address is not a valid</mat-error
                  >
                </div>
              </div>
            </div>
            <div class="section-data">
              <div class="group">
                <div class="label">IP Address Type</div>
                <mat-select
                  name="ipAddrType"
                  class="option-list"
                  #ipAddrTypeInput="ngModel"
                  [(ngModel)]="formField.ipAddrType"
                  (selectionChange)="onIpAddressTypeChange()"
                >
                  <mat-option *ngFor="let ipTypes of ipAddressTypes" [value]="ipTypes.value">{{
                    ipTypes.name
                  }}</mat-option>
                </mat-select>
              </div>
            </div>
            <div class="section-data">
              <div class="group" *ngIf="showFormField(configMapping?.DEFINED_ADDRESS)">
                <div class="label">Defined address using</div>
                <mat-select
                  class="option-list"
                  #definedAddressInput="ngModel"
                  [(ngModel)]="formField.definedAddress"
                  name="definedAddress"
                  (selectionChange)="onDefinedAddressChange()"
                  required
                >
                  <ng-container *ngFor="let type of definedAddressTypes">
                    <mat-option *ngIf="type.enabled" [value]="type.value">{{
                      type.name
                    }}</mat-option>
                  </ng-container>
                </mat-select>
              </div>
              <div class="group">
                <div class="label">Address *</div>
                <input
                  matInput
                  type="text"
                  class="input-group"
                  name="Address"
                  [(ngModel)]="formField.initiatorIp"
                  #addressInput="ngModel"
                  (ngModelChange)="addressUpdated()"
                  required
                />
                <div
                  class="error"
                  *ngIf="addressInput.invalid && (addressInput.dirty || addressInput.touched)"
                >
                  <mat-error *ngIf="addressInput.errors.required">Address is required</mat-error>
                </div>
                <div class="error">
                  <mat-error *ngIf="formField.initiatorIp && !formField.isAddressValid"
                    >Address is not valid</mat-error
                  >
                </div>
              </div>
            </div>
            <div class="section-data">
              <div class="group">
                <div class="label">{{ getSubnetLabel() }} *</div>
                <input
                  #cidrInput
                  matInput
                  type="text"
                  class="input-group"
                  name="subnet"
                  [(ngModel)]="formField.subnet"
                  #subnetInput="ngModel"
                  (ngModelChange)="subnetUpdated()"
                  required
                />
                <div
                  class="error"
                  *ngIf="subnetInput.invalid && (subnetInput.dirty || subnetInput.touched)"
                >
                  <mat-error *ngIf="subnetInput.errors.required">{{
                    subnetError('required')
                  }}</mat-error>
                </div>
                <div class="error">
                  <mat-error
                    *ngIf="(formField.subnet && !formField.isSubnetValid) || subnetValidation()"
                    >{{ subnetError('valid') }}</mat-error
                  >
                </div>
              </div>
              <div class="group">
                <div class="label">Gateway *</div>
                <input
                  #cidrInput
                  matInput
                  type="text"
                  class="input-group"
                  name="gateway"
                  [(ngModel)]="formField.gatewayIp"
                  #gatewayInput="ngModel"
                  (ngModelChange)="gatewayUpdated()"
                  required
                />
                <div
                  class="error"
                  *ngIf="gatewayInput.invalid && (gatewayInput.dirty || gatewayInput.touched)"
                >
                  <mat-error *ngIf="gatewayInput.errors.required">Gateway is required</mat-error>
                </div>
                <div class="error">
                  <mat-error
                    *ngIf="
                      (formField.gatewayIp && !formField.isGatewayValid) || gatewayIpValidation()
                    "
                    >Gateway is not valid</mat-error
                  >
                </div>
              </div>
            </div>
            <div class="section-data">
              <div class="group">
                <div class="label">Base UDP Port *</div>
                <input
                  matInput
                  class="input-group"
                  type="number"
                  name="baseUdpPort"
                  [(ngModel)]="formField.senderUdpPort"
                  #baseUdpPortInput="ngModel"
                  (ngModelChange)="baseUdpPortUpdated()"
                  min="49152"
                  max="65472"
                  value="50000"
                  maxlength="5"
                  required
                />
                <div
                  class="error"
                  *ngIf="
                    baseUdpPortInput.invalid && (baseUdpPortInput.dirty || baseUdpPortInput.touched)
                  "
                >
                  <mat-error *ngIf="baseUdpPortInput.errors.required"
                    >Base UDP port is required</mat-error
                  >
                </div>
                <div class="error">
                  <mat-error
                    *ngIf="
                      formField.senderUdpPort && !validityInitUdpCheck(formField.senderUdpPort)
                    "
                    >Valid range 49152-65472</mat-error
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <nrwl-endpoint-selection-panel
            [endpointValue]="destinationValue"
            (openEndpoint)="viewDestination()"
            [endpointConfiguration]="destinationConfiguration"
          ></nrwl-endpoint-selection-panel>
        </div>
      </div>
    </div>
    <div class="section-container network_container">
      <div class="label-data label">
        <span class="network_label">Network</span>
      </div>
      <div class="network_configuration_row">
        <div class="vlan">
          <label>VLAN Config</label>
          <mat-select
            class="option-list"
            #vlanConfigInput="ngModel"
            name="vlanConfigInput"
            [(ngModel)]="formField.vlanConfig"
            (ngModelChange)="onVlanConfigChange()"
          >
            <mat-option *ngFor="let mode of vlanConfigTypes" [value]="mode.value">
              {{ mode.name }}</mat-option
            >
          </mat-select>
        </div>
        <div class="lan_container" *ngIf="formField.vlanConfig !== 'untagged'">
          <div class="svlan">
            <label *ngIf="formField.vlanConfig !== 'tagged'">S-VLAN</label
            ><label *ngIf="formField.vlanConfig === 'tagged'">VLAN</label>
            <input
              matInput
              type="number"
              class="network_row_input"
              #sVlanInput="ngModel"
              name="sVlanInput"
              [(ngModel)]="formField.svlan"
              required
              min="1"
              max="4095"
              (ngModelChange)="onSVlanChange()"
            />
            <span
              class="error"
              *ngIf="sVlanInput.invalid && (sVlanInput.dirty || sVlanInput.touched)"
            >
              <mat-error *ngIf="sVlanInput.errors.required">Vlan is required</mat-error>
              <mat-error *ngIf="sVlanInput.errors.min || sVlanInput.errors.max"
                >Valid range 1 and 4065</mat-error
              >
            </span>
          </div>
          <div class="spriority">
            <label *ngIf="formField.vlanConfig !== 'tagged'">S-VLAN Priority</label
            ><label *ngIf="formField.vlanConfig === 'tagged'">VLAN Priority</label>
            <input
              matInput
              type="number"
              class="network_row_input"
              #sVlanPriorityInput="ngModel"
              name="sVlanPriorityInput"
              [(ngModel)]="formField.svlanPriority"
              required
              min="0"
              max="7"
              [disabled]="editMode"
              (ngModelChange)="onSVlanPriorityChange()"
            />
            <span
              class="error"
              *ngIf="
                sVlanPriorityInput.invalid &&
                (sVlanPriorityInput.dirty || sVlanPriorityInput.touched)
              "
            >
              <mat-error *ngIf="sVlanPriorityInput.errors.required"
                >Vlan Priority is required</mat-error
              >
              <mat-error *ngIf="sVlanPriorityInput.errors.min || sVlanPriorityInput.errors.max"
                >Valid range 0 and 7</mat-error
              >
            </span>
          </div>
          <div class="cvlan" *ngIf="formField.vlanConfig !== 'tagged'">
            <label>C-VLAN</label>
            <input
              matInput
              type="number"
              class="network_row_input"
              #cVlanInput="ngModel"
              name="cVlanInput"
              [(ngModel)]="formField.cvlan"
              required
              min="1"
              max="4065"
              (ngModelChange)="onCVlanChange()"
            />
            <span
              class="error"
              *ngIf="cVlanInput.invalid && (cVlanInput.dirty || cVlanInput.touched)"
            >
              <mat-error *ngIf="cVlanInput.errors.required">C-Vlan is required</mat-error>
              <mat-error *ngIf="cVlanInput.errors.min || cVlanInput.errors.max"
                >Valid range 1 and 4065</mat-error
              >
            </span>
          </div>
          <div class="cpriority" *ngIf="formField.vlanConfig !== 'tagged'">
            <label>C-VLAN Priority</label>
            <input
              matInput
              type="number"
              class="network_row_input"
              #cVlanPriorityInput="ngModel"
              name="formField.cVlanPriority"
              [(ngModel)]="formField.cvlanPriority"
              (ngModelChange)="onCVlanPriorityChange()"
              required
              min="0"
              max="7"
              [disabled]="editMode"
            />
            <span
              class="error"
              *ngIf="
                cVlanPriorityInput.invalid &&
                (cVlanPriorityInput.dirty || cVlanPriorityInput.touched)
              "
            >
              <mat-error *ngIf="cVlanPriorityInput.errors.required"
                >C-Vlan Priority is required</mat-error
              >
              <mat-error *ngIf="cVlanPriorityInput.errors.min || cVlanPriorityInput.errors.max"
                >Valid range 0 and 7</mat-error
              >
            </span>
          </div>
          <div *ngIf="formField.vlanConfig !== 'tagged'">
            <label>Ethertype</label>
            <mat-select
              class="option-list"
              #cvlanEthertypeInput="ngModel"
              name="cvlanEthertypeInput"
              [(ngModel)]="formField.cvlanEtherType"
              (ngModelChange)="onCVlanEtherTypeChange()"
            >
              <mat-option *ngFor="let ether of etherTypesData" [value]="ether.value">{{
                ether.name
              }}</mat-option>
            </mat-select>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
